//
// Module for the Direct Deposit Index view
//
rs.module("content/system/configuration/interest/index",

    ["controls/data/grid"],

    function (gridModule) {

        //
        // Initialize the module
        //
        function initialize(lrsGridApi, jsSelectors, ajaxUrl) {

            var filter = $.js(jsSelectors.filter);

            // Hook up click event on the radio buttons to reload the grid data via ajax
            filter.js(jsSelectors.interestParametersAsOfDate).find("input").on('click', function () {

                filter.js(jsSelectors.loadingSpinner).show();

                gridModule.update(

                    ajaxUrl,
                    { dateFilter: this.value },

                    lrsGridApi.agGridApi,

                    function done() {
                        filter.js(jsSelectors.loadingSpinner).hide();
                    }
                );
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);